// in NodeJS `SEPARATOR` is used, but since loader is only used
// on the browser side, we can always safely use `/`
const SEPARATOR = "/";

const normalize = (pathname) => {
  // Split the file path into an array of path segments
  const segments = pathname.split(SEPARATOR);

  // Remove any empty or current directory (.) segments
  const filteredSegments = segments.filter(
    (segment) => segment && segment !== "."
  );

  // Resolve any parent directory (..) segments
  const resolvedSegments = [];
  for (const segment of filteredSegments) {
    if (segment === "..") {
      resolvedSegments.pop();
    } else {
      resolvedSegments.push(segment);
    }
  }

  // Join the resolved segments into a normalized path
  const normalizedPath = resolvedSegments.join(SEPARATOR);

  // adds slash in the end if the original path had it
  if (pathname.endsWith(SEPARATOR) && !normalizedPath.endsWith(SEPARATOR)) {
    return normalizedPath + SEPARATOR;
  }

  return normalizedPath;
};

const retrieveFilenameFromPath = (pathname) => {
  const filename = pathname.split("/").pop();
  const filenameSegments = filename.split(".");

  // in case if file doesn't contain any extension
  // (e. g. audio files can have no extensions, because
  // loader component will define it itself based on the browser)
  if (filenameSegments.length === 1) {
    return filename;
  }

  const filenameWithoutExtension = filenameSegments.slice(0, -1).join(".");
  return filenameWithoutExtension;
};

const hasExtension = (pathname) => {
  const SPACE = " ";

  const filename = pathname.split(SEPARATOR).pop();
  if (!filename.includes(".")) return false;

  const extension = filename.split(".").pop();

  const rules = [
    extension.includes(SPACE),
    extension.length < 3,
    extension.length > 4,
  ];

  return !rules.some(Boolean);
};

const appendFileExtension = (pathname, extension) => {
  const filename = pathname.split(SEPARATOR).pop();
  return `${pathname.slice(0, -filename.length)}${filename}.${extension}`;
};

export {
  normalize,
  retrieveFilenameFromPath,
  hasExtension,
  appendFileExtension,
};
